import React, { useEffect, useState } from 'react';
import './plantillaWhatsapp.css';

const MegaLotoExpress = ({ sorteos, dataUsers, sorteodata }) => {
  const [cartones, setCartones] = useState(sorteodata.arryPuestos);
  const [sorteo, setSorteo] = useState(sorteodata);

  useEffect(() => {
    const posicion = sorteos.findIndex(obj => obj.id === sorteodata.id);
    setSorteo(sorteos[posicion]);
    setCartones(sorteos[posicion].arryPuestos);
  }, [sorteos, sorteodata]);

  // Función para generar la plantilla como texto
  const generarPlantilla = () => {
    let plantilla = `🪷🪷 MEGA LOTO EXPRESS 🍀🍀\nPUESTO         ${sorteo.valor}\nPREMIO 🏆  $${sorteo.typeLot === 'Express' ? sorteo.premioBase : sorteo.premio}\n\n🚨 ¡PARTICIPA Y GANA! 🚨\n¡SOLO ${sorteo.puestos} CARTONES PARA MAS OPORTUNIDADES DE GANAR! 🏵🏆\n\n🧩 CARTONES 🧩\n`;

    if(sorteo.puestos === 100){
      cartones.forEach(carton => {
        let [numero, nombre] = Object.entries(carton)[0];
        if (nombre) {
          const posicion = dataUsers.findIndex(obj => obj.id === nombre);
          nombre = dataUsers[posicion]?.nombre || nombre;
        }
        plantilla += `🍀${numero} ${nombre ? `- ${nombre} 🪴✅` : ''}\n`;
      });
      console.log(plantilla)
    }else{
      cartones.filter(carton => Object.values(carton)[0]).forEach(carton => {
        let [numero, nombre] = Object.entries(carton)[0];
        if (nombre) {
          const posicion = dataUsers.findIndex(obj => obj.id === nombre);
          nombre = dataUsers[posicion]?.nombre || nombre;
          plantilla += `🍀${numero} - ${nombre}\n`;
        }
      });
    }

    plantilla += `\n💰🎆 PAGAS POR 🤑🎇\nNEQUI-DAVIPLATA\n📲 3229344830 📌\n📲 Da click en el enlace: https://megaloto-express.web.app/dashboard 📌\n¡Gracias a todos por participar!`;
    return plantilla;
  };

  // Función para copiar al portapapeles
  const copiarPlantilla = () => {
    const plantilla = generarPlantilla();
    navigator.clipboard.writeText(plantilla).then(() => {
      //alert('Plantilla copiada al portapapeles!');
    });
  };

  return (
    <div className="container">
      <h1>🪷🪷 MEGA LOTO EXPRESS 🍀🍀</h1>
      <p>PUESTO: ${sorteo.valor}</p>
      <p className="prize">PREMIO 🏆 ${sorteo.typeLot === 'Express' ? sorteo.premioBase : sorteo.premio}</p>

      <h2 className="participa">🚨 ¡PARTICIPA Y GANA! 🚨</h2>
      <button className="copy-button" onClick={copiarPlantilla}>
        Copiar Plantilla
      </button>
      <p>¡SOLO {sorteo.puestos} CARTONES PARA MAS OPORTUNIDADES DE GANAR! 🏵🏆</p>

      <ul className="cartones">
        {/* Mapeo solo de los cartones que tienen un nombre */}
        {sorteo.puestos === 100
          ? cartones.map((carton, index) => {
            let [numero, nombre] = Object.entries(carton)[0];
            if (nombre) {
              const posicion = dataUsers.findIndex(obj => obj.id === nombre);
              nombre = dataUsers[posicion]?.nombre || nombre;
            }
            return (
              <li key={numero}>
                <span>🍀{numero}</span>
                <span className={nombre ? 'ocupado' : ''}>
                  {nombre ? `- ${nombre}` : ''}
                </span>
              </li>
            );
          })
          :cartones.filter(carton => Object.values(carton)[0]).map((carton, index) => {
            let [numero, nombre] = Object.entries(carton)[0];
            const posicion = dataUsers.findIndex(obj => obj.id === nombre);
            nombre = dataUsers[posicion]?.nombre || nombre;
            
            return (
              <li key={numero}>
                <span>🍀{numero}</span>
                <span className='ocupado'>
                  {`- ${nombre}`}
                </span>
              </li>
            );
          })
        }
      </ul>

      <div className="footer">
        <p className="pagas">💰🎆 PAGAS POR 🤑🎇</p>
        <p>NEQUI-DAVIPLATA</p>
        <p className="contacto">
          📲 <a href='https://megaloto-express.web.app/dashboard'>da click en el enlace: https://megaloto-express.web.app/dashboard</a> 📌
        </p>
        <p>¡Gracias a todos por participar!</p>
      </div>
    </div>
  );
};

export default MegaLotoExpress;
